module.exports = __webpack_public_path__ + "img/iGuh.52ddf8b1.png";